{
  "table": {
    "newBanner": "Nuevo Banner",
    "name": "Nombre",
    "roleProfiles": "Perfiles de Rol",
    "lastUpdated": "Última Actualización",
    "activeDateRange": "Rango de Fechas Activo",
    "status": {
      "title": "Estado",
      "states": {
        "DRAFT": "Borrador",
        "SCHEDULED": "Programado",
        "ACTIVE": "Activo",
        "EXPIRED": "Expirado"
      }
    },
    "organization": "Organización",
    "actions": {
      "delete": "Eliminar",
      "setToDraft": "Establecer como Borrador"
    }
  },
  "useParentAlertBanners": "Heredar banners de alerta de la organización principal",
  "alertBanner": "banner de alerta",
  "newBanner": "Nuevo Banner de Alerta",
  "editBanner": "Editar Banner de Alerta",
  "transitionError": "Este banner ya no está disponible",
  "bannerForm": {
    "name": "Nombre",
    "roleProfile": {
      "title": "Perfil(es) de Rol",
      "placeholder": "Seleccione todos los que apliquen"
    },
    "bannerType": {
      "title": "Tipo de Banner",
      "INFO": "Información: Úselo para información sobre nuevas funciones, actualizaciones de la aplicación, etc.",
      "SUCCESS": "Éxito: Úselo para comunicar un evento positivo o afirmativo.",
      "WARNING": "Advertencia: Úselo para información de alta prioridad, como el próximo mantenimiento del sistema.",
      "URGENT": "Urgente: Úselo para comunicaciones urgentes, como una alerta de fraude o seguridad."
    },
    "bannerCopy": {
      "title": "Texto del Banner (límite de 150 caracteres)",
      "placeholder": "Ingrese el texto del banner aquí"
    },
    "configuration": {
      "displayOnWeb": "Mostrar en el portal web",
      "displayOnIOS": "Mostrar en la aplicación iOS",
      "displayOnAndroid": "Mostrar en la aplicación Android",
      "makeDismissible": "Hacer descartable",
      "enableAction": "Habilitar botón de acción"
    },
    "actionButton": {
      "url": "URL",
      "label": "Etiqueta del Botón",
      "urlError": "Ingrese una URL válida que comience con http:// o https://"
    },
    "persistenceBehaviour": {
      "title": "Comportamiento de Persistencia",
      "FIRST_SESSION": {
        "title": "Mostrar en la primera sesión",
        "description": "Mostrar la primera vez que el usuario inicia sesión, pero no en sesiones posteriores."
      },
      "EVERY_SESSION": {
        "title": "Mostrar en cada sesión",
        "description": "Mostrar durante cada nueva sesión dentro del Rango de Fechas Activo, incluso si el usuario descarta el banner."
      },
      "UNTIL_DISMISSED": {
        "title": "Mostrar hasta que se descarte",
        "description": "Mostrar durante cada sesión hasta que el usuario descarte el banner."
      },
      "UNTIL_ACTIONED": {
        "title": "Mostrar hasta que se actúe",
        "description": "Mostrar durante cada sesión hasta que el usuario haga clic en el botón de acción asociado."
      }
    },
    "activeDateRange": {
      "startDate": "Hora de Inicio ({{timeZone}})",
      "endDate": "Hora de Fin ({{timeZone}})"
    },
    "actions": {
      "preview": {
        "title": "Vista Previa",
        "close": "Cerrar"
      },
      "saveDraft": "Guardar Borrador",
      "scheduleBanner": "Programar Banner",
      "updateBanner": "Actualizar Banner",
      "activateImmediately": {
        "title": "Activar Inmediatamente",
        "description": "El Rango de Fechas Activo incluye el día actual, lo que significa que el banner se mostrará inmediatamente.",
        "cancel": "Cancelar",
        "confirm": "Confirmar"
      },
      "toasts": {
        "draftSaved": "Borrador guardado.",
        "bannerStatus": "El nuevo banner de alerta ha sido {{status}}.",
        "activated": "activado",
        "scheduled": "programado"
      }
    }
  },
  "filterModal": {
    "title": "Filtrar",
    "status": "Estado",
    "cancel": "Cancelar",
    "apply": "Aplicar",
    "showStatus": "Mostrar {{status}}"
  },
  "alertBannerDeleteModal": {
    "deleteAlertBanner": "¿Eliminar Banner de Alerta?",
    "untitled": "Sin título",
    "wantToProceed": "Está a punto de eliminar el banner de alerta {{name}}. Esta acción no se puede deshacer.",
    "deletedSuccessfully": "Banner de alerta eliminado con éxito.",
    "setToDraftSuccessfully": "Banner de alerta establecido como borrador con éxito."
  }
}
